<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">Download {{ data.type }}</h5>
    <button
      type="button"
      class="close"
      (click)="onCancelClick()"
      aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form
    class="my-4 p-4"
    (ngSubmit)="onSubmit()"
    style="max-width: 400px; margin: auto">
    <div class="form-group d-flex align-items-center">
      <label for="language" class="mr-2">Download in:</label>
      <select
        id="language"
        name="language"
        class="form-control"
        [(ngModel)]="formData.language"
        style="width: 100px">
        <option *ngFor="let language of languages" [value]="language.value">
          {{ language.label }}
        </option>
      </select>
    </div>

    <div class="form-check mb-3 d-flex align-items-center label-justify">
      <label class="" for="isDeadHead">Include Dead Head</label>
      <input
        type="checkbox"
        class="form-check-input"
        id="isDeadHead"
        name="isDeadHead"
        [(ngModel)]="formData.isDeadHead" />
    </div>

    <div class="form-check mb-3 d-flex align-items-center label-justify">
      <label class="" for="isChecked">Include Flight Time</label>
      <input
        type="checkbox"
        class="form-check-input"
        id="isChecked"
        name="isChecked"
        [(ngModel)]="formData.isChecked" />
    </div>

    <div class="form-check mb-3 d-flex align-items-center label-justify">
      <label class="" for="isLayoverTime">Include Layover Time</label>
      <input
        type="checkbox"
        class="form-check-input"
        id="isLayoverTime"
        name="isLayoverTime"
        [(ngModel)]="formData.isLayoverTime" />
    </div>

    <button type="submit" class="btn btn-primary mt-3">Submit</button>
  </form>

  <!-- Additional modal sections (e.g., footer) if needed -->
</div>
